import React from "react";
import { TooltipProps } from "recharts";
import styled from "styled-components";
import { DataItem } from "..";
import { Divider } from "Components";
import { useMultiDayEventContext } from "contexts/MultiDayEventContext";

export const Tooltip: React.FC<TooltipProps<number, string>> = ({
  active,
  payload,
}) => {
  const { startDate, endDate } = useMultiDayEventContext();
  const isSameDay = startDate.hasSame(endDate, "day");

  if (!active || !payload || !payload.length) return null;

  const { date, entries, visits, uniqueVisits, clicks } = payload[0]
    .payload as DataItem;

  const stats: Record<string, number> = {
    "Total Entries": entries,
    "Total Visits": visits,
    "Unique Visits": uniqueVisits,
    Clicks: clicks,
  };

  return (
    <Container>
      <Date>
        {isSameDay
          ? date.toFormat("h a").toLocaleLowerCase()
          : date.toFormat("MMM dd")}
      </Date>
      <StyledDivider />
      <Stats>
        {Object.entries(stats).map(([label, value]) => (
          <React.Fragment key={label}>
            <StatLabel>{label}</StatLabel>
            <StatValue>{value}</StatValue>
          </React.Fragment>
        ))}
      </Stats>
    </Container>
  );
};

const Container = styled.div`
  border-radius: 8px;
  background: var(--content-background-color);
  box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.15);
  padding: 10px 0;
  width: 200px;
`;

const Date = styled.span`
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: var(--main-color);
  text-align: center;
  padding-top: 2px;
`;

const StyledDivider = styled(Divider)`
  margin: 7px 0 10px;
`;

const Stats = styled.div`
  display: grid;
  grid-template-columns: auto max-content;
  column-gap: 10px;
  row-gap: 12px;
  padding: 5px 15px;
  font-size: 14px;
`;

const StatLabel = styled.span`
  color: var(--secondary-text-color);
`;

const StatValue = styled.span`
  color: var(--text-color);
  width: 100%;
  text-align: center;
  font-weight: 500;
`;
